import { render, staticRenderFns } from "./ordiniDaConfermare.html?vue&type=template&id=a879c742&"
import script from "./OrdiniDaConfermare.vue?vue&type=script&lang=js&"
export * from "./OrdiniDaConfermare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports